import i18n from 'l10n';
import moment from 'moment';
import {$, Backbone} from "backboneAdapter";


export const setupAjaxConfiguration = async function (router, entitySizePredicate, postpaidPredicate, callingCodeWithDefaultCountry) {
    const $data = $('[data-i18n]');
    $data.i18n();
    const $html = $('html');
    $html.attr('lang', i18n.language);
    $html.attr('dir', i18n.getDir());
    $('body').addClass(i18n.getDir());
    $data.each(function () {
        if (typeof $(this).data("hint") === "string") {
            $.Metro.initAll(this);
        }
    });

    $.ajaxSetup({
        complete: function (xhr) {
            if (xhr.status === 401) {
                console.info(xhr.status);
                sessionStorage.setItem("referrer", location.pathname + location.hash);
                window.open('/CampaignCloud/cloudui/home/Login.htm', '_self');
            }
        },
        beforeSend: function (xhr) {
            xhr.setRequestHeader('X-TZ-Offset', -(new Date()).getTimezoneOffset());
            xhr.setRequestHeader('X-TZ-Name', moment.tz.guess());
            xhr.setRequestHeader('Accept-Language', i18n.language);
            if (window.csrf)
                xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
        },
        error: function (jqXHR) {
            if (entitySizePredicate !== undefined) {
                if (entitySizePredicate(jqXHR)) {
                    $.Notify.error(`Error ${jqXHR.status}`);
                }
            } else {
                $.Notify.error(`Error ${jqXHR.status}`);
            }
        }
    });
    let deferred;
    try {
        deferred = $.ajaxDefaultQ({
            url: '/CampaignCloud/RememberMeController/ping',
            type: 'GET',
            dataType: 'json'
        });
        const response = await deferred;
        window.csrf = deferred.getResponseHeader('X-CSRF-TOKEN');
        if (response.status === 'success') {
            if (postpaidPredicate !== undefined) {
                postpaidPredicate(deferred);
            }
            if (callingCodeWithDefaultCountry) {
                callingCodeWithDefaultCountry.init();
            }
            const isPostPaid = deferred.getResponseHeader("isPostPaid") === "true";
            new router({isPostPaid});
            Backbone.history.start();
        } else {
            console.info(response);
            sessionStorage.setItem("referrer", location.pathname + location.hash);
            window.open('Login.htm', '_self');
        }
    } catch (e) {
        console.error(e);
        window.csrf = deferred.getResponseHeader('X-CSRF-TOKEN');
        sessionStorage.setItem("referrer", location.pathname + location.hash);
        window.open('Login.htm', '_self');
    }
};

